// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/legacy/" + "imask" + "." + "10a16f2f" + ".js";
};